'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MarkdownContainer = require('./MarkdownContainer');

var _MarkdownContainer2 = _interopRequireDefault(_MarkdownContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      styles: {
        margin: '16px 16px 36px'
      },
      docsBeforePreview: this.$props.docs.docsBeforePreview,
      docsAfterPreview: this.$props.docs.docsAfterPreview
    };
  },

  components: { MarkdownContainer: _MarkdownContainer2.default },
  props: ['docs'],
  template: '\n    <div v-bind:style="styles">\n      <markdown-container :docs="docsBeforePreview" />\n      <slot></slot>\n      <markdown-container :docs="docsAfterPreview" />\n      <slot name="footer"></slot>\n    </div>\n  '
};